import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';

export interface Config extends BaseConfig {
    id: string | null;
    modalTitle: string;
    noticeMessage: string;
    updatedDate: string;
    showMessageButton?: string;
    closeMessageButton?: string;
}

export const defaultConfig: Config = {
    id: null,
    modalTitle: '',
    noticeMessage: '',
    updatedDate: '',
    showMessageButton: '',
    closeMessageButton: '',
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
